import { ProductTypeService } from './setup/services/product-type.service';
import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutes } from './app.routes';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import {MultiSelectModule} from 'primeng/multiselect';
import { BankingSharedModule } from './shared/shared.module';
// import { GMapModule } from 'primeng/components/gmap/gmap';

import { AuthGuard } from './admin/guard/authentication.guard';
import { AppConfigService } from './shared/services/app.config.service';
import { AppConfig } from './shared/constant/app.config';
import { AuthHttp } from './admin/services/token.service';
import { AppComponent } from './app.component';
import { MainLayoutComponent } from './shared/layout/mainlayout.component';
import { AuthLayoutComponent } from './shared/layout/authlayout.component';
import { AppMenuComponent, AppSubMenuComponent } from './shared/common/app.menu.component';
import { AppTopBarComponent } from './shared/common/app.topbar.component';
import { AppFooterComponent } from './shared/common/app.footer.component';
import { InlineProfileComponent } from './shared/common/app.profile.component';

import { NotificationService } from './shared/services/notification.service';
import { MenuVisibiltyService } from './shared/services/role-menu.service';
import { AuthenticationService } from './admin/services/authentication.service';
import { DashboardComponent } from './dashboard/app.dashboard.component';

import { PushNotificationsService, PushNotificationsModule } from 'ng-push';
import { ConfirmDeactivateGuard } from './admin/guard/confirm-deactivate.guard';
import { AdminService, AuthorizationService, StaffService, ExchangeRateService } from './admin/services';

 
//import { IdleTimeoutService } from 'app/shared/services/IdleTimeoutService.service';
//import { DialogService } from 'app/shared/services/dialog.service';
// import { FormatMoneyDirective } from './shared/directives/formatmoney.onblur.directive';
import { HelperService } from './shared/services/helpers.service';
import { PasswordSettingComponent } from './profile/password-reset/password-reset.component';
import { LoadingService } from './shared/services/loading.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CompanyService, BranchService, DepartmentService, CountryStateService, StaffRoleService, JobTitleService, MisInfoService, StaffRealTimeSearchService, GeneralSetupService, RiskIndexService, CollateralService, LoanCovenantService, ConditionPrecedentService, CurrencyService, ProductService, LedgerService, DocumentService, RequestJobTypeService, CallMemoService, ApprovalService, ChecklistService, ProductFeeService, AccreditedConsultantsService, CustomerFSCaptionService, CustomFieldService, RiskRatingService, ProductGroupService, ProductCategoryService, ChartOfAccountService, DealClassificationService, LimitsService, ChargeService, EndOfDayService, MonitoringSetupService } from './setup/services';
import { LoanService, CustomerRealTimeSearchService, CreditAppraisalService, RiskAssessmentService, JobService, LoanOperationService, CreditApprovalService, BulkRateService, LoanReviewApplicationService, LoanApplicationService, LoanPrepaymentService } from './credit/services';
import { UtilityService } from './shared/services/util.service';
import { CrmsService } from './shared/services/crms.service';
import { ValidationService } from './shared/services/validation.service';
import { CustomerService } from './customer/services/customer.service';
import { CasaService } from './customer/services/casa.service';
import { DateUtilService } from './shared/services/dateutils';
import { CustomerGroupService } from './customer/services/customer-group.service';
import { ReportService } from './reports/service/report.service';
import { PrintService } from './shared/services/print.service';
import { OverrideService } from './credit/services/override.service';
import { LoanRecoveryPaymentPlanService } from './credit/services/loan-recovery-paymentplan.service';
import { CreditBureauService } from './credit/services/credit-bureau.service';
import { FeeConcessionService } from './credit/services/fee-concession.service';
import { ContingentLoanService } from './credit/loans/contingent-usage/contingentloan.service';
import { LoanPerformanceService } from './credit/services/loan-performance.service';
import { AvailmentRouteComponent } from './credit/routes/availment-route.component';
import { CollateralInformationComponent } from './credit/collateral';
import { LetterOfCreditService } from './credit/services/letter-of-credit.service';
import { LetterGenerationRequestService } from './credit/services/letter-generation-request.service';
import { ProjectSiteReportService } from './credit/services/project-site-report.service';
import { CustomFieldsService } from './shared/services/customFields/custom-fields.service';
import { ImageService } from './shared/services/imageupload.service';
import { RegulatoryService } from './setup/services/regulatory.service';
import { LimitMaintenanceService } from './setup/services/limit-maintenance.service';
import { LoanRecoverySetupService } from './setup/services/loan-recovery-setup.service';
import { FxAccountService } from './setup/services/fx-account.service';
import { RacService } from './setup/services/rac.service';
import { TokenInterceptor } from './admin/services/TokenInterceptor.service';
import { ScreenLockComponent } from './auth/screen-lock.component';
import { PwaService } from './pwa/pwa.service';
import { NotifcationComponent } from './notification-list/app.notification.component';


export function initConfig(config: AppConfig) {
    return () => config.load();
}

@NgModule({
    imports: [
        BrowserModule,
        AppRoutes,
        HttpClientModule,
        BrowserAnimationsModule,
        PushNotificationsModule,
        BankingSharedModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
    ],
    declarations: [
        AppComponent,
        MainLayoutComponent,
        AppMenuComponent,
        AppSubMenuComponent,
        InlineProfileComponent,
        AppTopBarComponent,
        AppFooterComponent,
        AuthLayoutComponent,
        DashboardComponent,
        PasswordSettingComponent,
        ScreenLockComponent,
        NotifcationComponent


        //PasswordValidation
        //CKEDITOR,
        // FormatMoneyDirective,
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
         },
        AppConfigService, AppConfig, Title,
        { provide: APP_INITIALIZER, useFactory: initConfig, deps: [AppConfig], multi: true },
        AuthGuard,
        AuthenticationService,
        MenuVisibiltyService,
        AuthHttp, PushNotificationsService, PushNotificationsService,
        NotificationService, ConfirmDeactivateGuard, AdminService, LoadingService, DashboardService,
        HelperService,
        AuthorizationService,
        PwaService,
        CompanyService,
        BranchService, DepartmentService,
        StaffService, AuthHttp, LoanService,
        UtilityService,
        CountryStateService,
        StaffRoleService, JobTitleService,
        MisInfoService, ExchangeRateService,
        StaffRealTimeSearchService, CrmsService
        , GeneralSetupService,
        ValidationService, RiskIndexService, CollateralService,
        LoanCovenantService, CustomerService, CasaService, ConditionPrecedentService,
        CustomerRealTimeSearchService, CurrencyService, DateUtilService, CreditAppraisalService,
        RiskAssessmentService, ProductService, LedgerService, DocumentService, RequestJobTypeService,
        JobService, CallMemoService, LoanOperationService,
        CreditApprovalService, ApprovalService, CustomerGroupService, ChecklistService,
        ReportService, BulkRateService, LoanReviewApplicationService,
        LoanApplicationService, PrintService, ProductFeeService, OverrideService, LoanRecoveryPaymentPlanService,
        CreditBureauService, FeeConcessionService, LoanPrepaymentService, ContingentLoanService,
        LoanPerformanceService, AccreditedConsultantsService, AvailmentRouteComponent
        , CollateralInformationComponent, LetterOfCreditService, LetterGenerationRequestService,
        CollateralInformationComponent, ProjectSiteReportService,
        CustomerFSCaptionService,
        CustomFieldService,
        RiskRatingService,
        ProductTypeService, 
        ProductGroupService, 
        ProductCategoryService,
        ChartOfAccountService, 
        DealClassificationService,
        LimitsService,
        CustomFieldsService,
        ImageService, ChargeService,
        EndOfDayService,
        RegulatoryService,
        LimitMaintenanceService, 
        LoanRecoverySetupService,
        MonitoringSetupService,
        FxAccountService, 
        RacService

    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
